document.addEventListener('click', function (event) {
  if (event.target.closest('.add-to-cart')) {
    event.preventDefault();

    const button = event.target.closest('.add-to-cart');
    const form = button.closest('form');
    if (!form) return;

    const formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then(() => {
        document.dispatchEvent(new Event('cart:updated'));
      })
      .catch((error) => console.error('Error:', error));
  }
});
